import { TABLE_GRID } from 'modules/experiments/constants';
import { EXPERIMENTS_TABLE_COLUMNS, EXPERIMENTS_TABLE_COLUMN } from 'modules/experiments/types';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { HeaderRowCell } from './HeaderRowCell';

type HeaderRowProps = {
  sortedBy: EXPERIMENTS_TABLE_COLUMNS;
  setSortedBy: (sortBy: EXPERIMENTS_TABLE_COLUMNS) => void;
  sortDirection: SORT_DIRECTIONS;
  setSortDirection: (sortDirection: SORT_DIRECTIONS) => void;
  columns: EXPERIMENTS_TABLE_COLUMN[];
};

export const HeaderRow = ({
  sortedBy,
  setSortedBy,
  sortDirection,
  setSortDirection,
  columns,
}: HeaderRowProps) => {
  return (
    <HeaderGridRow gridLayout={TABLE_GRID}>
      {/* For MultiSelect
        <CheckboxWrapper>
        <StyledGroupSelect
          key="styled-group-select-experiments"
          onSelectAll={noop}
          onSelectNone={noop}
        />
      </CheckboxWrapper> */}
      {columns.map((column) => (
        <HeaderRowCell
          column={column}
          columnId={column.id}
          key={column.id}
          isActiveSortColumn={column.id === sortedBy}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          setSortedBy={setSortedBy}
        />
      ))}
      <div data-test="placeholder-column-for-action-button" />
    </HeaderGridRow>
  );
};
